<ngb-pagination [collectionSize]="pagination.collectionSize"
                [page]="pagination.page"
                [pageSize]="pagination.pageSize"
                [maxSize]="pagination.maxSize"
                [rotate]="pagination.rotate"
                (pageChange)="handlePageChange($event)">
  <ng-template ngbPaginationPrevious>‹</ng-template>
  <ng-template ngbPaginationNext>›</ng-template>
</ngb-pagination>
